import { graphql } from '@api/mesa'

const CREATE_RECURRING_PAYMENT = graphql(`
  mutation createRecurringPayment(
    $highnoteExternalAccountId: String!
    $transferAmountStrategy: TransferBalanceAmountCode!
    $transferDayOfMonth: Int!
    $consentTimestamp: String!
  ) {
    createRecurringPaymentV2(
      highnoteExternalAccountId: $highnoteExternalAccountId
      transferAmountStrategy: $transferAmountStrategy
      transferDayOfMonth: $transferDayOfMonth
      consentTimestamp: $consentTimestamp
    ) {
      __typename
      ... on MesaUserError {
        message
      }
    }
  }
`)

export const CardPaymentsGqlMutations = {
  CREATE_RECURRING_PAYMENT,
}
